// extracted by mini-css-extract-plugin
export default {"history-detail":"index_history-detail__qY4hC"};